import { Model } from '@hub-components';

export interface SnapshotSharingPermissionsJSON {
  overview?: boolean;
  breakdown?: boolean;
  comparisons?: boolean;
  breakdown_cost_based_metrics?: boolean;
  breakdown_viewability_metrics?: boolean;
  datasets?: { [datasetId: string]: boolean };
}

export class SnapshotSharingPermissions extends Model {
  overview?: boolean;
  breakdown?: boolean;
  comparisons?: boolean;
  breakdownCostBasedMetrics?: boolean;
  breakdownViewabilityMetrics?: boolean;
  datasets?: { [datasetId: string]: boolean };

  constructor(obj: Partial<SnapshotSharingPermissionsJSON> = {}) {
    super(obj);
  }

  public asJson(): SnapshotSharingPermissionsJSON {
    return {
      overview: this.overview,
      breakdown: this.breakdown,
      comparisons: this.comparisons,
      breakdown_cost_based_metrics: this.breakdownCostBasedMetrics,
      breakdown_viewability_metrics: this.breakdownViewabilityMetrics,
      datasets: this.datasets,
    };
  }
}
